import React, { useState } from "react"
import Proptypes from "prop-types"
import { Container, Row, Col } from "reactstrap"
// import back from '../../../images/careers/Full Stack engineer.png';

const Grid = props => {
  return (
    <div className="main">
      <div className="headin large-font">{props.headin}</div>
      <div className="sub-headin small-font">{props.sub_headin}</div>
      <Row className="rowstyle">
        {props.bottomtext_black ? (
          <Col xs="12" sm="6" className="info-area">
            <div className="table-area">
              <table class="w3-table">
                <tr>
                  {props.tblhead_white ? (
                    <th className=" tblhead">{props.tblhead_white}</th>
                  ) : (
                    ""
                  )}
                  {props.tblhead_black ? <th>{props.tblhead_black}</th> : ""}
                </tr>
                {props.td_text1 ? (
                  <tr>
                    <td>{props.td_text1}</td>
                    <td>{props.td_text2}</td>
                    <td>{props.td_text3}</td>
                  </tr>
                ) : (
                  ""
                )}
                {props.td_text4 ? (
                  <tr>
                    <td>{props.td_text4}</td>
                    <td>{props.td_text5}</td>
                  </tr>
                ) : (
                  ""
                )}
                {props.tec_li1 ? (
                  <ul className="ulist3">
                    <li>{props.tec_li1}</li>
                    <li>{props.tec_li2}</li>
                    <li>{props.tec_li3}</li>
                    <li>{props.tec_li4}</li>
                    <li>{props.tec_li5}</li>
                    <li>{props.tec_li6}</li>
                    <li>{props.tec_li7}</li>
                  </ul>
                ) : (
                  ""
                )}
              </table>
            </div>
            <div className="list-area">
              {props.requirment_white ? (
                <div className="Mid-font req-text1">
                  {props.requirment_white}
                </div>
              ) : (
                ""
              )}
              {props.requirment_black ? (
                <div className="Mid-font req-text">
                  {props.requirment_black}
                </div>
              ) : (
                ""
              )}

              <ul className="ulist">
                <li>{props.li_txt1}</li>
                <li>{props.li_txt2}</li>
                <li>{props.li_txt3}</li>
                <li>{props.li_txt4}</li>
                <li>{props.li_txt5}</li>
                <li>{props.li_txt6}</li>
                <li>{props.li_txt7}</li>
              </ul>

              {props.bottomtext_white ? (
                <div className=" bottom-text-white">
                  {props.bottomtext_white}
                </div>
              ) : (
                ""
              )}
              {props.bottomtext_black ? (
                <div className="bottom-text-black">
                  {props.bottomtext_black}
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
        ) : (
          ""
        )}
        {props.requirment_white ? (
          <Col xs="12" sm="6" className="info-area1">
            <div className="table-area">
              <table class="w3-table" className="white_tbl">
                <tr>
                  {props.tblhead_white ? (
                    <th className=" tblhead">{props.tblhead_white}</th>
                  ) : (
                    ""
                  )}
                  {props.tblhead_black ? <th>{props.tblhead_black}</th> : ""}
                </tr>
                {props.td_text1 ? (
                  <tr>
                    <td>{props.td_text1}</td>
                    <td>{props.td_text2}</td>
                    <td>{props.td_text3}</td>
                  </tr>
                ) : (
                  ""
                )}
                {props.td_text4 ? (
                  <tr>
                    <td>{props.td_text4}</td>
                    <td>{props.td_text5}</td>
                  </tr>
                ) : (
                  ""
                )}
                {props.tec_li1 ? (
                  <ul className="ulist3">
                    <li>{props.tec_li1}</li>
                    <li>{props.tec_li2}</li>
                    <li>{props.tec_li3}</li>
                    <li>{props.tec_li4}</li>
                    <li>{props.tec_li5}</li>
                    <li>{props.tec_li6}</li>
                    <li>{props.tec_li7}</li>
                  </ul>
                ) : (
                  ""
                )}
              </table>
            </div>
            <div className="list-area">
              {props.requirment_white ? (
                <div className="Mid-font req-text1">
                  {props.requirment_white}
                </div>
              ) : (
                ""
              )}
              {props.requirment_black ? (
                <div className="Mid-font req-text">
                  {props.requirment_black}
                </div>
              ) : (
                ""
              )}

              <ul className="ulist2">
                <li>{props.li_txt1}</li>
                <li>{props.li_txt2}</li>
                <li>{props.li_txt3}</li>
                <li>{props.li_txt4}</li>
                <li>{props.li_txt5}</li>
                <li>{props.li_txt6}</li>
                <li>{props.li_txt7}</li>
              </ul>

              {props.bottomtext_white ? (
                <div className="bottom-text-white">
                  {props.bottomtext_white}
                </div>
              ) : (
                ""
              )}
              {props.bottomtext_black ? (
                <div className="bottom-text-black">
                  {props.bottomtext_black}
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
        ) : (
          ""
        )}
        <Col xs="12" sm="6" style={{ padding: 0 }}>
          <img
            className="border-image"
            src={props.side_img}
            alt="Customized Mobile Apps for Jitsi Meet. Contact Meetrix.IO now !"
          />
        </Col>
      </Row>
    </div>
  )
}
Grid.prototype = {
  headin: Proptypes.any,
  sub_headin: Proptypes.any,
  side_img: Proptypes.any,
  bottomtext_white: Proptypes.any,
  bottomtext_black: Proptypes.any,
  tblhead_white: Proptypes.any,
  tblhead_black: Proptypes.any,
  td_text1: Proptypes.any,
  td_text2: Proptypes.any,
  td_text3: Proptypes.any,
  td_text4: Proptypes.any,
  td_text5: Proptypes.any,

  requirment_white: Proptypes.any,
  requirment_black: Proptypes.any,

  li_txt1: Proptypes.any,
  li_txt2: Proptypes.any,
  li_txt3: Proptypes.any,
  li_txt4: Proptypes.any,
  li_txt5: Proptypes.any,
  li_txt6: Proptypes.any,
  li_txt7: Proptypes.any,

  tec_li1: Proptypes.any,
  tec_li2: Proptypes.any,
  tec_li3: Proptypes.any,
  tec_li4: Proptypes.any,
  tec_li5: Proptypes.any,
  tec_li6: Proptypes.any,
  tec_li7: Proptypes.any,
}
export default Grid
